<template>
  <div class="solution-page-container" v-cloak>
    <nav-bar model="blue"></nav-bar>
    <banner></banner>
    <solution-content></solution-content>
    <partner></partner>
    <customize></customize>
    <page-footer></page-footer>
  </div>
</template>

<script>
import navBar from "../common/navBar";
import banner from "./components/banner";
import solutionContent from "./components/solutionContent";
import partner from "./components/partner";
import customize from "../common/customize";
import pageFooter from "../common/pageFooter";
export default {
  components: {
    navBar,
    banner,
    solutionContent,
    partner,
    customize,
    pageFooter,
  },
  data() {
    return {};
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
  },
};
</script>

<style lang="scss" scoped>
.solution-page-container {
}
</style>



// WEBPACK FOOTER //
// src/view/solution/solution.vue